export const BUILD_CURRENCY_FORMAT_CONSTANTS = {
    TEMP_STRING: '@',
    NO_DIGITS: '0-0',
    TWO_DIGITS_INFO: '2-2',
    DEFAULT_LOCALE: 'en-US'
};
